import React from 'react';
import { useSelector } from 'react-redux';

import {
  adaptStoreToActiveFacetResetHrefs,
  getClearAllFacetsHref,
} from 'src/adapters/storeToPageURL/adaptStoreToUIFacetHrefs';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectActiveFacets } from 'src/redux/productsQuery/selectors/selectors';
import { ActiveFacets } from './ActiveFacets';

export const ActiveFacetsContainer = () => {
  const state = useSelector((state: ReduxApplicationState) => state);
  const allActiveFacets = selectActiveFacets(state);
  const activeFacets = adaptStoreToActiveFacetResetHrefs(state, allActiveFacets);
  const clearAllHref = allActiveFacets.length > 0 ? getClearAllFacetsHref(state) : undefined;

  return <ActiveFacets activeFacets={activeFacets} clearAllHref={clearAllHref} />;
};
